export default __webpack_public_path__ + "static/media/ep1collage6.4fee1a72.jpg";